export default "__VITE_ASSET__CVoaGaMX__"